/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macronutrients: protein, carbohydrate and fat. They provide the calories in food and are tracked in grams for diet and training goals.`)
};

const es_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macronutrientes: proteína, carbohidratos y grasa. Aportan las calorías de los alimentos y se controlan en gramos según objetivos de dieta y entrenamiento.`)
};

const de_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makronährstoffe: Protein, Kohlenhydrate und Fett. Sie liefern die Kalorien in Nahrungsmitteln und werden für Ernährungs- und Trainingsziele in Gramm erfasst.`)
};

const nl_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macronutriënten: eiwit, koolhydraten en vet. Ze leveren de calorieën in voeding en worden in grammen bijgehouden voor dieet- en trainingsdoelen.`)
};

const fr_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les macronutriments : protéines, glucides et lipides. Ils apportent les calories des aliments et sont suivis en grammes pour les objectifs alimentaires et d'entraînement.`)
};

const it_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macronutrienti: proteine, carboidrati e grassi. Forniscono le calorie negli alimenti e vengono tracciati in grammi per gli obiettivi di dieta e allenamento.`)
};

const pt_br2_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macronutrientes: proteína, carboidrato e gordura. Eles fornecem as calorias dos alimentos e são acompanhados em gramas para metas de dieta e treino.`)
};

const pt_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macronutrientes: proteína, hidratos de carbono e gordura. Fornecem as calorias dos alimentos e são contabilizados em gramas para objetivos de dieta e treino.`)
};

const ja_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タンパク質、炭水化物、脂質のことです。食品のカロリー源であり、食事やトレーニングの目標に合わせてグラム数で管理されます。`)
};

const zh_macro_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三大营养素指蛋白质、碳水化合物和脂肪。它们提供食物中的热量，并以克数记录用于饮食和训练目标。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_faq_a1", locale)
	if (locale === "en") return en_macro_faq_a1(inputs)
	if (locale === "es") return es_macro_faq_a1(inputs)
	if (locale === "de") return de_macro_faq_a1(inputs)
	if (locale === "nl") return nl_macro_faq_a1(inputs)
	if (locale === "fr") return fr_macro_faq_a1(inputs)
	if (locale === "it") return it_macro_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_macro_faq_a1(inputs)
	if (locale === "pt") return pt_macro_faq_a1(inputs)
	if (locale === "ja") return ja_macro_faq_a1(inputs)
	return zh_macro_faq_a1(inputs)
};